import { render } from "./SlashIcon.vue?vue&type=template&id=4aec537e"
import script from "./SlashIcon.vue?vue&type=script&lang=js"
export * from "./SlashIcon.vue?vue&type=script&lang=js"

import "./SlashIcon.vue?vue&type=style&index=0&id=4aec537e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__